import React from 'react'

interface StatusBadgeProps {
  children: React.ReactNode
  colorClass: string
  className?: string
}

const StatusBadge: React.FC<StatusBadgeProps> = ({
  children,
  colorClass,
  className = '',
}) => {
  return (
    <span
      className={`inline-flex items-center justify-center px-2.5 py-0.5 rounded-full text-xs font-medium text-center whitespace-normal break-words ${colorClass} ${className}`.trim()}
    >
      {children}
    </span>
  )
}

export default StatusBadge
